import appStore from 'store';
import api from './api';
import { STATUS_TYPES } from './constants';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    StaffSumLists: [],
    projects: [],
    coinTypeList: [],
    totalCount: 0,
    editingProject: null,
    pagination: {
      page: 1,
      size: 25
    },
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: item.toString(),
        label: LANGUAGE[item]
      };
    })
  },
  getters: {},
  mutations: {
    setList(state, payload) {
      state.projects = payload;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    StaffSumList(state, payload) {
      state.StaffSumLists = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
      });
    },
    add(context, data) {
      return api.add(data);
    },
    getStaffSumList({ commit }, data) {
      return api.getStaffSumList().then(({ data }) => {
        commit('StaffSumList', data);
      });
    },
    update(context, data) {
      return api.update(data);
    }
  }
};

appStore.registerModule('staff', store);
